module.exports = __webpack_public_path__ + "files/00df55e79fd1b33fa1318d3c5567a7ac.png";